import {GlobalLocationTypes, Reservation, SelectOptionType} from 'utils/types';
import {PhoneInputRef} from '../acommon/FieldPhoneInput/PhoneInput';

export enum LockVendors {
  salto = 's',
}

export enum FieldTypes {
  text = 'TEXT',
  date = 'DATE',
  file = 'FILE',
  time = 'TIME',
  select = 'SELECT',
  phone = 'PHONE',
}

export type LocationType = {
  country: {
    code: string;
    name: string;
  };
};

export type PurposeOfStayType = {
  id: string;
  name: string;
};

export type DistrictType = {
  country: {
    code: string;
    name: string;
  };
  division_level_1: {
    code: string;
    name: string;
    type: string;
  };
};

export type MunicipalityType = {
  country: {
    code: string;
    name: string;
  };
  division_level_1: {
    code: string;
    name: string;
    type: string;
  };
  division_level_2: {
    code: string;
    name: string;
    type: string;
  };
};

export type CityType = {
  country: {
    code: string;
    name: string;
  };
  division_level_1: {
    code: string;
    name: string;
    type: string;
  };
  division_level_2: {
    code: string;
    name: string;
    type: string;
  };
  division_level_3: {
    code: string;
    name: string;
    type: string;
  };
};

export type TaxExemptionType = {
  name: string;
  id: string;
  stat_type: string;
};

export type ProvincesType = {
  results: [
    {
      division_level_2: {
        code: string;
        name: string;
        type: string;
      };
    },
  ];
};

export type CustomField = {
  field_type: FieldTypes;
  id: string;
  is_custom: boolean;
  is_required: boolean;
  name: string;
  names: {[key: string]: string}[];
  placeholders: {[key: string]: string}[];
};

export type CustomForm = {
  country: string;
  fields_set: {
    form_id: string;
    id: string;
    order: number;
    is_required: boolean;
    is_leaders_field: boolean;
    field: CustomField;
  }[];
  housings: string[];
  id: string;
  name: string;
  required_id_or_passport: boolean;
};

export enum FORM_NAMES {
  name = 'name',
  surname = 'surname',
  secondSurname = 'second_surname',
  birthDate = 'birthDate',
  sex = 'sex',
  nationality = 'nationality',
  docType = 'docType',
  docNumber = 'docNumber',
  countryOfIssue = 'countryOfIssue',
  italianCityOfIssue = 'italianCityOfIssue',
  docDateOfIssue = 'docDateOfIssue',
  birthCountry = 'birthCountry',
  italianCityOfBirth = 'italianCityOfBirth',
  residenceCountry = 'residenceCountry',
  residenceCity = 'residenceCity',
  italianResidenceCity = 'italianResidenceCity',
  residenceAddress = 'residenceAddress',
  cityOfBirth = 'cityOfBirth',
  cityOfIssue = 'cityOfIssue',
  nextDestinationCountry = 'nextDestinationCountry',
  nextDestinationCity = 'nextDestinationCity',
  nextDestinationAddress = 'nextDestinationAddress',
  nextDestinationDistrict = 'nextDestinationDistrict',
  nextDestinationMunicipality = 'nextDestinationMunicipality',
  residencePostalCode = 'residencePostalCode',
  residenceProvince = 'residenceProvince',
  citizenship = 'citizenship',
  purposeOfStay = 'purposeOfStay',
  visaNumber = 'visaNumber',
  arrivalCountry = 'arrivalCountry',
  arrivalDistrict = 'arrivalDistrict',
  arrivalMunicipality = 'arrivalMunicipality',
  taxExemption = 'taxExemption',
  fiscalCode = 'fiscalCode',
  email = 'email',
  phone = 'phone',
}

export enum EXTRA_FORM_NAMES {
  signature = 'signature',
  phoneDetails = 'phone_details',
}

export type FormTypes = {
  [FORM_NAMES.name]: string | null;
  [FORM_NAMES.surname]: string | null;
  [FORM_NAMES.secondSurname]: string;
  [FORM_NAMES.sex]?: SelectOptionType | null;
  [FORM_NAMES.birthDate]: Date | null;
  [FORM_NAMES.nationality]: SelectOptionType | null;
  [FORM_NAMES.docType]?: SelectOptionType | null;
  [FORM_NAMES.docNumber]: string;
  [FORM_NAMES.docDateOfIssue]: Date | null;
  [FORM_NAMES.birthCountry]: SelectOptionType | null;
  [FORM_NAMES.residenceCountry]: SelectOptionType | null;
  [FORM_NAMES.residenceCity]: SelectOptionType | string | null;
  [FORM_NAMES.countryOfIssue]: SelectOptionType | null;
  [FORM_NAMES.cityOfBirth]: SelectOptionType | string | null;
  [FORM_NAMES.cityOfIssue]: SelectOptionType | string | null;
  [FORM_NAMES.residenceAddress]: string;
  [FORM_NAMES.nextDestinationCountry]: SelectOptionType | null;
  [FORM_NAMES.nextDestinationCity]: string;
  [FORM_NAMES.nextDestinationAddress]: string;
  [FORM_NAMES.residencePostalCode]: string;
  [FORM_NAMES.citizenship]: SelectOptionType | null;
  [FORM_NAMES.purposeOfStay]: SelectOptionType | null;
  [FORM_NAMES.visaNumber]: string | null;
  [FORM_NAMES.arrivalCountry]: SelectOptionType | null;
  [FORM_NAMES.arrivalDistrict]: SelectOptionType | null;
  [FORM_NAMES.arrivalMunicipality]?: SelectOptionType | null;
  [FORM_NAMES.nextDestinationDistrict]: SelectOptionType | null;
  [FORM_NAMES.nextDestinationMunicipality]?: SelectOptionType | null;
  [FORM_NAMES.taxExemption]: SelectOptionType | null;
  [FORM_NAMES.residenceProvince]: SelectOptionType | null;
  [FORM_NAMES.fiscalCode]: string | null;
  [FORM_NAMES.phone]: string | null;
  [EXTRA_FORM_NAMES.phoneDetails]?: PhoneInputRef;
  [FORM_NAMES.email]?: string;
  [FORM_NAMES.fiscalCode]: string | null;
  [key: string]: any;
};

export type RequiredFields = {
  [key: string]: string | boolean;
};

export type FormFieldsTypes = {
  [FORM_NAMES.birthCountry]: string | number;
  [FORM_NAMES.countryOfIssue]: string | number;
  [FORM_NAMES.citizenship]: string | number;
  [FORM_NAMES.arrivalCountry]: string | number;
  [FORM_NAMES.nextDestinationCountry]: string | number;
  [FORM_NAMES.docType]: string | number;
  [FORM_NAMES.residenceCountry]: string | number;
};

export type FieldsDataTypes = {
  reservation: Reservation;
  isSaltoLock: boolean;
  isCustomForm: boolean;
  isPoliceActivated?: boolean;
  nationalityCode?: string | number;
  residenceCountry?: string | number;
  docType?: string | number;
  formFields?: FormFieldsTypes;
};

export type LocationStatePersonalForm = GlobalLocationTypes & {
  number_of_guests: number;
  formData?: any;
  children?: number;
  highlightFormFields?: boolean;
  ocrWasUsed?: boolean;
  biomatch?: {
    biomatch_passed: boolean;
    biomatch_doc: string;
    biomatch_selfie: string;
  };
  updatedCheckInDate: string;
  updatedCheckOutDate: string;
};
